module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"firstName":"Имя","lastName":"Фамилия","email":"E-mail","save":"Сохранить","dataSaved":"Данные изменены"}}')
  delete Component.options._Ctor
}
